export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const GET_CAMPAIGN = 'GET_CAMPAIGN';
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const LOADING = 'LOADING';
export const COLLAPSE_SIDEBAR = 'COLLAPSE_SIDEBAR';
export const REDIRECT_TO = 'REDIRECT_TO';
